module.exports = __webpack_public_path__ + "static/media/zwzproduct12.3c9adc38.jpg";